<template>
  <div v-if="basicConf.overflowX" :style="bgstyle">
    <webp-img :src="imgUrl || basicConf.url" :style="style" class="mars-image" />
  </div>
  <webp-img v-else :src="imgUrl || basicConf.url" :style="style" class="mars-image" />
</template>
<script>
export default {
    name: 'MarsImage',
    props: {
        editableData: {
            type: Object,
            default: function() {
                return {
                    basic: {}
                }
            }
        }
    },
    data() {
        return {
            imgUrl: ''
        }
    },
    computed: {
        basicConf: function() {
            return this.editableData.basic
        },
        // style: function() {
        //     return {
        //         'object-fit': this.basicConf.size,
        //         'vertical-align': 'middle'
        //     }
        // }
        style: function() {
            if (this.basicConf.overflowX) {
                return {
                    'width': 'auto',
                    'height': '100%'
                }
            }
            return {
                'object-fit': this.basicConf.size,
                'vertical-align': 'middle'
            }
        },
        bgstyle: function() {
            if (this.basicConf.overflowX) {
                return {
                    'overflow-x': 'scroll',
                    'height': '100%',
                    'width': '100%'
                }
            }
            return {}
        }
    },
    methods: {
        changeImage(value) {
            let obj = value.url
            if (this.basicConf.imgKey) {
                const keys = this.basicConf.imgKey.split('.')
                while (keys.length > 0) {
                    const key = keys.shift()
                    if (obj[key]) {
                        obj = obj[key]
                    } else {
                        return this.imgUrl = value.url
                    }
                }
            }
            return this.imgUrl = obj
        }
    }
}
</script>

<style lang="scss">
    @import './../webp.scss';
    .mars-image{
        width: 100%;
        height: 100%;
        display: block;
    }
</style>

